import SvgGourdeIcon from "@Components/CustomIcon/SvgGourdeIcon"
import SvgPhysics from "@Components/CustomIcon/SvgPhysics"
import SvgPoidsIcon from "@Components/CustomIcon/SvgPoids"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { TouchableOpacity, View } from "react-native"

export const ToolboxAPACardItem = (props) => {
    return (
        <TouchableOpacity onPress={() => props.onPress && props.onPress()} activeOpacity={0.8}>
            <View
                style={{
                    marginVertical: 15,
                    overflow: "hidden",
                    backgroundColor: baseColors.orange.dark,
                    height: 127,
                    borderRadius: 10
                }}
            >
                <View style={{ position: "absolute", bottom: 0 }}>
                    <SvgGourdeIcon height={84} width={29} />
                </View>
                <View style={{ flex: 1, justifyContent: "center", alignContent: "center", alignItems: "center" }}>
                    <BreeSerifText color={baseColors.white} fontSize={24}>
                        Programme APA
                    </BreeSerifText>
                </View>
                <View style={{ position: "absolute", left: 20, bottom: -5 }}>
                    <SvgPoidsIcon height={62} width={80} />
                </View>
                <View style={{ position: "absolute", right: -10, top: 10 }}>
                    <SvgPhysics height={62} width={80} />
                </View>
            </View>
        </TouchableOpacity>
    )
}
